import { HttpStatusCode } from '~settings/api/lib/types';

import type { ToastMessage } from '../../hooks/useToast.tsx';

export const getMessageFromStatus = (
  status: HttpStatusCode,
  isEditing = false,
): ToastMessage => {
  switch (status) {
    case HttpStatusCode.EntityConflict:
      return {
        title: 'user.errors.userAlreadyExistsTitle',
        description: 'user.errors.userAlreadyExistsMessage',
      };
    case HttpStatusCode.Forbidden:
      if (isEditing) {
        return {
          title: 'user.errors.noPermissionTitle',
          description: 'user.errors.noPermissionEditMessage',
        };
      }

      return {
        title: 'user.errors.noPermissionTitle',
        description: 'user.errors.noPermissionCreateMessage',
      };
    case HttpStatusCode.BadRequest:
      return {
        title: 'user.errors.validationErrorTitle',
        description: 'user.errors.validationErrorMessage',
      };
    default:
      if (isEditing) {
        return {
          title: 'user.errors.userEditTitle',
          description: 'user.errors.userEditMessage',
        };
      }

      return {
        title: 'user.errors.userCreateTitle',
        description: 'user.errors.userCreateMessage',
      };
  }
};
